import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/software-gestion-servicios/CrmClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/schema/FAQSchema.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/schema/ServiceSchema.tsx");
